import throttle from "lodash.throttle"
import meganav from './meganav'

const navOpenClass = 'meganav-is-open'

const init = () => {
	
	// Find meganav element
	const nav = document.querySelector('[data-meganav]')

	// If found...
	if (nav !== null) {

		meganav()

		// Get required elements
		const root         = document.documentElement;
		const navToggle    = nav.querySelector('[data-meganav-toggle]')
		const navTopLinks  = nav.querySelectorAll('.meganav__link--top[aria-haspopup]')
		const navLinks     = nav.querySelectorAll('.meganav__link[aria-haspopup]')

		// Keyboard codes
		const KEYS = {
			ESC: 27,
			TAB: 9,
			ENTER: 13,
			SPACE: 32,
			LEFT: 37,
			UP: 38,
			RIGHT: 39,
			DOWN: 40
		}

		// When toggle button clicked, toggle classes on html
		navToggle.addEventListener('click', (e)=> {
			if (e.target.getAttribute('aria-expanded') === 'true') {
				root.classList.add(navOpenClass)
			} else {
				root.classList.remove(navOpenClass)
			}
		});
		
		// If any top level links in menu clicked, add 'open' class to root el
		[].forEach.call(navTopLinks, (link) => {
			link.addEventListener('click', () => {
				root.classList.add(navOpenClass)
			})
		});

		// When user clicks outside of meganav, it should close
		root.addEventListener('click', (e) => {
			const isClickInside = nav.contains(e.target)
			
			if (isClickInside) {
				return
			}
			root.classList.remove(navOpenClass);
		
			[].forEach.call(navLinks, (link) => {
				link.setAttribute('aria-expanded', false)
			})
		});

		// Listen for keyups
		window.addEventListener('keyup', (e) => {

			// When someone is tabbing through...
			if (e.which === KEYS.TAB) {

				// If no menu items are currently expanded...
				if (nav.querySelectorAll('a[aria-expanded="true"]').length < 1) {

					closeAll(root, navToggle)
				}

			}

			// When someone is trying to escape...
			if (e.which === KEYS.ESC) {

				// If no menu items are currently expanded...
				if (nav.querySelectorAll('a[aria-expanded="true"]').length < 1) {

					closeAll(root, navToggle)
				}

			}

		}, false);

		// When window is scrolled, close meganav
		window.addEventListener('scroll', throttle((e) => {
			for (const tlLink of nav.querySelectorAll('.meganav__item--top > a')) {

				tlLink.classList.remove('is-active');
				tlLink.setAttribute('aria-expanded', 'false');
			}
		}, 100), false);
	}
}

const closeAll = (root, toggle) => {

	// Remove open class from root el
	root.classList.remove(navOpenClass)

	// Set nav toggle to not be expanded
	toggle.setAttribute('aria-expanded', false)

}

export default init